import React from "react";
import { connect } from "react-redux";

import {
  onDropDownsChange,
  onMobileBetFilterClick,
} from "../../../redux/actions/sportEventsActions";

import { Bets } from "../../";
import { Utils, Constants, CountryCodes } from "../../../helpers";
import { Images } from "../../";

import { Select } from "antd";
import { useMediaQuery } from "react-responsive";
import { filterSportEvents } from "../../../redux/actions/sportEventsActions";

const Option = Select.Option;

const Odd = (props) => {
  const { children } = props;
  return <div className="odd">{children}</div>;
};

const ColSelect = (props) => {
  const {
    title,
    onChange,
    selectOptions,
    defaultValue,
    selectedBetType,
  } = props;

  return (
    <div className="odds">
      <div className="select">
        {title && <div className="title upper">{title}</div>}

        {!title && (
          <Select
            defaultValue={defaultValue}
            className="selectlist"
            onChange={onChange}
          >
            {selectOptions &&
              selectOptions.optionsBetTypes &&
              selectOptions.optionsBetTypes.map((item, index) => (
                <Option key={item.key} value={item.key}>
                  {item.betTypeName}
                </Option>
              ))}
          </Select>
        )}
      </div>
      <div className="odds-desc">
        {// if title exist - show match fields
        title &&
          selectOptions &&
          selectOptions.match &&
          selectOptions.match.eventOddFields &&
          sortByCol(selectOptions.match.eventOddFields).map((item, index) => (
            <Odd key={index}>{item.oddField}</Odd>
          ))}
        {// if no title show selected bet type fields
        !title &&
          selectOptions &&
          selectOptions.optionsBetTypes &&
          selectOptions.optionsBetTypes.length > 0 &&
          selectOptions.optionsBetTypes.map((item) => {
            return item.key == selectedBetType
              ? sortByCol(item.eventOddFields).map((field, index) => (
                  <Odd key={index}>{field.oddField}</Odd>
                ))
              : null;
          })}
      </div>
    </div>
  );
};
const IsMobile = ({ children }) => {
  const isMiddleScreenAndMobile = useMediaQuery({ maxWidth: 720 });
  return isMiddleScreenAndMobile ? children : null;
};
const IsDesktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 720 });
  return isDesktop ? children : null;
};

const sortByCol = (array) => {
  return Utils.sortArrayByAttribute(array, "oddFieldColumn");
};

class EventsHeader extends React.Component {
  //  if this.state.sportEventsFilter type is 3, that means filter favorites, and if it is 2 that means return all events
  state = {
    applyStyle: false,
    style: { backgroundColor: "#2C8AF7", opacity: "1" },
  };
  componentWillUnmount() {}

  getCountryCode = (name) => {
    let result = CountryCodes.Codes.filter((item) => {
      return item.name.toLowerCase() == name.toLowerCase();
    });

    return result && result.length > 0 ? result[0].code.toLowerCase() : "eu";
  };
  filterSportEvents = (filterType)=>{
    //  if filter type is 3, that means filter favorites, and if it 2 that means return all events
    const {filterSportEvents , setCurrentFilter}= this.props
    filterSportEvents(filterType)
    setCurrentFilter(filterType)
  }

  render() {
    const { match, title, betTypes, selectedValues , isFromEventsSports } = this.props;

    return (
      <div>
        <IsMobile>
          <>
          <div id="bits-filter-button-container">
              <button className="bets-filter-buttons">
                <span>
                  <img src={Images.DarkCup} alt="cup" />
                </span>
              </button>
              <button onClick={()=>this.filterSportEvents(2)} className="bets-filter-buttons" style={this.props.sportEventsFilter==2 ? this.state.style : {} }>
                <span>All</span>
              </button>
              <button onClick={()=>this.filterSportEvents(3)} className="bets-filter-buttons" style={this.props.sportEventsFilter==3 ? this.state.style : {} } disabled={isFromEventsSports}>
                <span>
                  <img src={Images.DarkStar} alt="star" />
                </span>
              </button>
              {/* {title && (
                <button className="bets-filter-buttons">{title}</button>
              )} */}
            </div>
            <div className="mobile-sort-by-filter">
              {title && <button>{title}</button>}
            </div>
            <div className="mobile-bets-filter-container">
              <div id="mobile-bets-filter-controller">
                {/* {title && <div className="title upper">{title}</div>} */}
                {betTypes && betTypes.match && (
                  <>
                    <div
                      id={betTypes.match.key}
                      onClick={() =>
                        this.resetSelectedValues(betTypes.match.key)
                      }
                      style={this.state.style}
                      className="mobile-bet-filter-options"
                    >
                      1 X 2
                    </div>
                    {betTypes &&
                      betTypes.optionsBetTypes &&
                      betTypes.optionsBetTypes.map(
                        (item, index) =>
                          !item.betTypeName.includes("Handicaps") && (
                            <div
                              key={item.key}
                              id={item.key}
                              onClick={() => this.filters(item.key)}
                              className="mobile-bet-filter-options"
                            >
                              <span>{item.betTypeName}</span>
                            </div>
                          )
                      )}
                  </>
                )}
                {betTypes && !betTypes.match && (
                  <>
                    {betTypes &&
                      betTypes.optionsBetTypes &&
                      betTypes.optionsBetTypes.map(
                        (item, index) =>
                          !item.betTypeName.includes("Handicaps") && (
                            <div
                              key={item.key}
                              id={item.key}
                              onClick={() => this.filters(item.key)}
                              style={index == 0 ? this.state.style : {}}
                              className="mobile-bet-filter-options"
                            >
                              <span>{item.betTypeName}</span>
                            </div>
                          )
                      )}
                  </>
                )}
              </div>
            </div>
          </>
        </IsMobile>
        <IsDesktop>
          <div className="bets-filter-container">
            <div id="bits-filter-button-container">
              <button className="bets-filter-buttons">
                <span>
                  <img src={Images.DarkCup} alt="cup" />
                </span>
              </button>
              <button onClick={()=>this.filterSportEvents(2)} className="bets-filter-buttons" style={this.props.sportEventsFilter==2 ? this.state.style : {} }>
                <span>All</span>
              </button>
              <button onClick={()=>this.filterSportEvents(3)} className="bets-filter-buttons" style={this.props.sportEventsFilter==3 ? this.state.style : {} } disabled={isFromEventsSports}>
                <span>
                  <img src={Images.DarkStar} alt="star" />
                </span>
              </button>
              {title && (
                <button className="bets-filter-buttons">{title}</button>
              )}
            </div>
            <div id="bits-filter" style={{ padding: "0" }}>
              <Bets.HeaderRow {...this.props} className="header">
                {betTypes && betTypes.match && (
                  <>
                    <Bets.EventsCol className="col bet-type-1">
                      <div className="bet-types">
                        <ColSelect
                          title={betTypes.match.betTypeName}
                          selectOptions={betTypes}
                        />
                      </div>
                    </Bets.EventsCol>
                    {betTypes &&
                      betTypes.optionsBetTypes &&
                      betTypes.optionsBetTypes.length >= 1 && (
                        <Bets.EventsCol
                          className="col bet-type-2"
                          style={{ marginLeft: "5px" }}
                        >
                          <div
                            className="bet-types"
                            style={{ marginLeft: "1.4rem" }}
                          >
                            <ColSelect
                              selectedBetType={selectedValues[0]}
                              onChange={(value) =>
                                this.onDropDownsChange(value, 0)
                              }
                              selectOptions={betTypes}
                              defaultValue={selectedValues[0]}
                            />
                          </div>
                        </Bets.EventsCol>
                      )}

                    {betTypes &&
                      betTypes.optionsBetTypes &&
                      betTypes.optionsBetTypes.length >= 2 && (
                        <Bets.EventsCol
                          className="col bet-type-3"
                          style={{ marginLeft: "5px" }}
                        >
                          <div
                            className="bet-types"
                            style={{ marginLeft: "2.7rem" }}
                          >
                            <ColSelect
                              selectedBetType={selectedValues[1]}
                              onChange={(value) =>
                                this.onDropDownsChange(value, 1)
                              }
                              selectOptions={betTypes}
                              defaultValue={selectedValues[1]}
                            />
                          </div>
                        </Bets.EventsCol>
                      )}

                    {betTypes &&
                      betTypes.optionsBetTypes &&
                      betTypes.optionsBetTypes.length >= 3 && (
                        <Bets.EventsCol className="col bet-type-4">
                          <div
                            className="bet-types"
                            style={{ marginLeft: "5.5rem" }}
                          >
                            <ColSelect
                              selectedBetType={selectedValues[2]}
                              onChange={(value) =>
                                this.onDropDownsChange(value, 2)
                              }
                              selectOptions={betTypes}
                              defaultValue={selectedValues[2]}
                            />
                          </div>
                        </Bets.EventsCol>
                      )}
                  </>
                )}
                {betTypes && !betTypes.match && (
                  <>
                    {betTypes &&
                      betTypes.optionsBetTypes &&
                      betTypes.optionsBetTypes.length >= 1 && (
                        <Bets.EventsCol
                          className="col bet-type-1"
                          style={{ marginLeft: "5px" }}
                        >
                          <div
                            className="bet-types"
                          >
                            <ColSelect
                              selectedBetType={selectedValues[0]}
                              onChange={(value) =>
                                this.onDropDownsChange(value, 0)
                              }
                              selectOptions={betTypes}
                              defaultValue={selectedValues[0]}
                            />
                          </div>
                        </Bets.EventsCol>
                      )}
                    {betTypes &&
                      betTypes.optionsBetTypes &&
                      betTypes.optionsBetTypes.length >= 2 && (
                        <Bets.EventsCol
                          className="col bet-type-2"
                          style={{ marginLeft: "5px" }}
                        >
                          <div
                            className="bet-types"
                            style={{ marginLeft: "1.5rem" }}
                          >
                            <ColSelect
                              selectedBetType={selectedValues[1]}
                              onChange={(value) =>
                                this.onDropDownsChange(value, 1)
                              }
                              selectOptions={betTypes}
                              defaultValue={selectedValues[1]}
                            />
                          </div>
                        </Bets.EventsCol>
                      )}

                    {betTypes &&
                      betTypes.optionsBetTypes &&
                      betTypes.optionsBetTypes.length >= 3 && (
                        <Bets.EventsCol
                          className="col bet-type-3"
                        >
                          <div
                            className="bet-types"
                            style={{ marginLeft: "3rem" }}
                          >
                            <ColSelect
                              selectedBetType={selectedValues[2]}
                              onChange={(value) =>
                                this.onDropDownsChange(value, 2)
                              }
                              selectOptions={betTypes}
                              defaultValue={selectedValues[2]}
                            />
                          </div>
                        </Bets.EventsCol>
                      )}
                  </>
                )}

                <Bets.EventsCol className="col bet-type-5">
                  <div className="stats">&nbsp;</div>
                </Bets.EventsCol>

                <Bets.EventsCol className="col bet-type-6">
                  <div className="plus">&nbsp;</div>
                </Bets.EventsCol>
              </Bets.HeaderRow>
            </div>
          </div>
        </IsDesktop>
      </div>
    );
  }

  onDropDownsChange(value, dropDownId) {
    const { selectedValues, onDropDownsChange } = this.props;
    let newSelectedValues = [];
    selectedValues.map((item, index) => {
      if (dropDownId == index) {
        newSelectedValues[index] = value;
      } else {
        newSelectedValues[index] = item;
      }
    });
    onDropDownsChange(newSelectedValues);
  }
  changeFilterColor(key, typeOfClicked) {
    if (this.state.id) {
      const disabledStyleElement = document.getElementById(this.state.id);
      disabledStyleElement.style.backgroundColor = "var(--dark-blue)";
      disabledStyleElement.style.opacity = "0.7";
    }
    typeOfClicked == "match"
      ? this.setState({
          // style:{},
          id: key,
        })
      : this.setState({
          style: {},
          id: key,
        });
    const enabledStyleElement = document.getElementById(key);
    enabledStyleElement.style.backgroundColor = "#2C8AF7";
    enabledStyleElement.style.opacity = "1";
  }
  filters(key) {
    const { onMobileBetFilterClick } = this.props;
    this.changeFilterColor(key, "other");
    return onMobileBetFilterClick(key);
  }
  resetSelectedValues(key) {
    const { onMobileBetFilterClick } = this.props;
    this.changeFilterColor(key, "match");
    onMobileBetFilterClick(undefined);
  }
}
const mapStateToProps = (state) => {
  return {
    betTypes: state.sportEvents.betTypes,
    selectedValues: state.sportEvents.selectedValues,
    selectedValue: state.sportEvents.selectedValue,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onDropDownsChange: (values) => {
      dispatch(onDropDownsChange(values));
    },
    onMobileBetFilterClick: (values) => {
      dispatch(onMobileBetFilterClick(values));
    },
    filterSportEvents: (filterType) => {
      dispatch(filterSportEvents(filterType));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsHeader);
